<style scoped="scoped" lang="scss">
.work {
  // display: flex;
  // flex-wrap: wrap;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  // padding: 8px 16px;
  // gap: 10px;
  margin-left: 7px;
  width: 450px;
  height: 190px;
  border: 1px solid #909399;
  // background: #F4F4F5;
  border-radius: 4px;

  // flex: none;
  // order: 5;
  // flex-grow: 0;
}
</style>
<style>
.el-select .el-input {
  width: 90px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/warning/setting/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yewuleixing')">
            <el-input v-model="yt.conditions.type"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yewumingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')">
            <el-select v-model="yt.conditions.isEnabled">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, beforeGet, afterGet)" type="primary" plain="plain" :loading="yt.loading">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' }, beforeGet, afterGet)" :loading="yt.loading">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)" v-if="utils.checkPower('web_early_warning_management_alert_settings_create')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #suoshuzuzhi="scope">
        <span>{{ scope.row.org.name }}</span>
      </template>
      <!-- 自定义某个字段 -->
      <template #yonghu="scope">
        <!-- 用戶 -->
        <template>
          <span>{{ scope.row.userObjects | getUserText }}</span>
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowEditDialogEdit)" v-if="utils.checkPower('web_early_warning_management_alert_settings_update')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xiaoxichakan', scope.row, 'w2')">{{ $t('xiaoxichakan') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yewuleixing/mingcheng')" required>
            <el-select v-model="yt.editObj.warningTypeId" :max="1" @change="changeValue" filterable>
              <el-option v-for="(item, index) in alertTypeList" :key="index" :label="item.typeName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('tongzhiqudao')" required>
            <yi_dictionary_select :max="10" :multiple="true" :type="'MESSAGE_CHANNEL'" :ids.sync="yt.editObj.channels" @change="channelChange"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item v-show="showRobotList" :label="$t('xiaoxijiqiren')" required>
            <el-select v-model="yt.editObj.configRobotIds" clearable multiple collapse-tags filterable :placeholder="$t('qingxuanze')">
              <el-option v-for="item in robotList" :key="item.id" :label="item.robotName" :value="item.id">
                <span style="float: left">{{ item.robotName }}</span>
                <span style="float: right; color: #8492a6; padding-right: 20px; font-size: 13px">{{ getRobotTypeName(item.robotType) }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="obj.code !== 'equipment_fault_group' && obj.code !== 'equipment_remove_fault_group' && codeName !== 'equipment_fault_group' && codeName !== 'equipment_remove_fault_group' && obj.code !== 'standard_cycle_compare' && codeName !== 'standard_cycle_compare'" v-show="showUserList" :label="$t('yonghu')" required>
            <yi_cross_select multiple :component="'web_system_user_list'" :fixConditions="warningUserCrossSelectFixConditions" :ids.sync="yt.editObj.userIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.isEnabled" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('peizhi')">
            <el-button :disabled="yt.editObj.warningTypeId != null && (obj.code === 'wo_status_warning' || obj.code === 'equipment_remove_fault' || obj.code === 'equipment_fault' || obj.code === 'production_plan_time_out' || obj.code === 'mould_repair_record_create' || obj.code === 'mould_repair_record_finish' || obj.code === 'equipment_repair_bill_create' || obj.code === 'equipment_repair_bill_result' || obj.code === 'production_wo_start_warning' || obj.code === 'equipment_process_stability' || obj.code === 'daily_efficiency_report' || obj.code === 'monthly_efficiency_report' || obj.code === 'standard_hr_compare') ? (disabled = true) : (disabled = false)" size="mini" type="primary" plain @click="showText()">
              {{ $t('peizhi') }}
            </el-button>
          </el-form-item>
          <br />
          <el-form-item :label="$t('peizhishijianfanwei')">
            <el-button size="mini" :disabled="(yt.editObj.warningTypeId != null && (obj.code === 'wo_status_warning' || obj.code === 'production_plan_time_out')) || (obj.code === 'oil_temperature_too_high' || obj.code === 'equipment_offline_warning' || obj.code === 'equipment_move' || obj.code === 'production_wo_start_warning' || obj.code === 'daily_efficiency_report' || obj.code === 'monthly_efficiency_report' || obj.code === 'standard_hr_compare') ? (disabled = true) : (disabled = false)" type="primary" plain @click="showTime()">
              {{ $t('peizhi') }}
            </el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="saveCreate" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('yewuleixing/mingcheng')" required>
            <!--            this.activeName = this.tab[this.active].id-->
            <el-select disabled v-model="yt.editObj.warningTypeId" :max="1" @change="changeEditValue">
              <el-option v-for="(item, index) in alertTypeList" :key="index" :label="item.typeName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('tongzhiqudao')" required>
            <yi_dictionary_select :max="10" :multiple="true" :type="'MESSAGE_CHANNEL'" :ids.sync="yt.editObj.channels" @change="channelChange"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item v-show="showRobotList" :label="$t('xiaoxijiqiren')" required>
            <el-select v-model="yt.editObj.configRobotIds" clearable multiple collapse-tags filterable :placeholder="$t('qingxuanze')">
              <el-option v-for="item in robotList" :key="item.id" :label="item.robotName" :value="item.id">
                <span style="float: left">{{ item.robotName }}</span>
                <span style="float: right; color: #8492a6; padding-right: 20px; font-size: 13px">{{ getRobotTypeName(item.robotType) }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="obj.code !== 'equipment_fault_group' && obj.code !== 'equipment_remove_fault_group' && codeName !== 'equipment_fault_group' && codeName !== 'equipment_remove_fault_group' && obj.code !== 'standard_cycle_compare' && codeName !== 'standard_cycle_compare'" v-show="showUserList" :label="$t('yonghu')" required>
            <yi_cross_select multiple :component="'web_system_user_list'" :fixConditions="warningUserCrossSelectFixConditions" :ids.sync="yt.editObj.userIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.isEnabled" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <div>
            <el-form-item :label="$t('peizhi')" v-if="yt.editObj.warningTypeId != null && codeName === 'equipment_move'">
              <el-button size="mini" type="primary" plain @click="showMoveText()">
                {{ $t('peizhi') }}
              </el-button>
            </el-form-item>
            <el-form-item :label="$t('peizhi')" v-else>
              <el-button :disabled="yt.editObj.warningTypeId != null && (codeName === 'equipment_remove_fault' || codeName === 'equipment_fault' || codeName === 'equipment_repair_bill_create' || codeName === 'equipment_repair_bill_result' || codeName === 'production_plan_time_out' || codeName === 'wo_status_warning' || obj.code === 'mould_repair_record_create' || obj.code === 'mould_repair_record_finish' || obj.code === 'equipment_repair_bill_create' || obj.code === 'equipment_repair_bill_result' || codeName === 'production_wo_start_warning' || codeName === 'equipment_process_stability' || codeName === 'daily_efficiency_report' || codeName === 'monthly_efficiency_report' || codeName === 'standard_hr_compare') ? (disabled = true) : (disabled = false)" size="mini" type="primary" plain @click="showText()">
                {{ $t('peizhi') }}
              </el-button>
            </el-form-item>
          </div>

          <br />
          <el-form-item :label="$t('peizhishijianfanwei')">
            <el-button size="mini" :disabled="yt.editObj.warningTypeId != null && (codeName === 'production_plan_time_out' || codeName === 'oil_temperature_too_high' || codeName === 'equipment_offline_warning' || codeName === 'wo_status_warning' || codeName === 'equipment_move' || codeName === 'production_wo_start_warning' || codeName === 'daily_efficiency_report' || codeName === 'monthly_efficiency_report' || codeName === 'standard_hr_compare') ? (disabled = true) : (disabled = false)" type="primary" plain @click="showEdit(yt.editObj)">
              {{ $t('peizhi') }}
            </el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="update" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action === 'xiaoxichakan'">
        <div class="dialog-scroller">
          <message_view :message="yt.editObj"></message_view>
        </div>
      </template>
    </el-dialog>
    <!-- 配置 注意：新增/编辑都在这=>obj.cod(新增)标志、codeName(编辑)标志-->
    <div>
      <el-dialog v-if="obj.code === 'equipment_move'" :show-close="true" :title="$t('peizhi')" :visible.sync="showSpotCheckDialog" width="80%" :close-on-click-modal="false" append-to-body="append-to-body">
        <div class="dialog-scroller">
          <move_list ref="move_list" :changeTypeIds="obj"></move_list>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelCreateDialog">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="saveMoveList" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </el-dialog>
      <el-dialog v-else-if="obj.code === 'equipment_fault_group' || obj.code === 'equipment_remove_fault_group' || codeName === 'equipment_fault_group' || codeName === 'equipment_remove_fault_group'" :show-close="true" :title="$t('peizhi')" :visible.sync="showEquipmentUserDialog" width="600px" :close-on-click-modal="false" append-to-body="append-to-body">
        <div class="dialog-scroller">
          <equipment_user_list v-if="showEquipmentUserDialog" ref="equipment_user_list" :itemList="yt.editObj.settingJson ? JSON.parse(yt.editObj.settingJson) : []"></equipment_user_list>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelCreateDialog">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="saveEquipmentUser" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </el-dialog>
      <el-dialog v-else :show-close="true" :title="$t('peizhi')" :visible.sync="showSpotCheckDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <div v-if="obj.code === 'inspect_auto_create_warning' || codeName === 'inspect_auto_create_warning'">
            <el-form-item :label="$t('jianyanleixing')" required="required">
              <el-select v-model="yt.editObj.inspectionType" clearable>
                <el-option :label="$t('shoujian')" :value="1"></el-option>
                <el-option :label="$t('choujian')" :value="2"></el-option>
                <el-option :label="$t('mojian')" :value="3"></el-option>
                <el-option :label="$t('chengpinjian')" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="obj.code === 'over_production' || codeName === 'over_production'">
            <el-form-item :label="$t('chaochanleixing')" required="required">
              <el-select v-model="yt.editObj.overProductionType">
                <el-option :label="$t('bili')" :value="0"></el-option>
                <el-option :label="$t('shuliang')" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('chaochanzhi')" required="required">
              <el-input v-model="yt.editObj.overProductionValue" type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jiangechaochanzhi')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.overProductionInterval"></el-input>
            </el-form-item>
          </div>
          <div v-if="obj.code === 'mould_life' || codeName === 'mould_life'">
            <el-form-item :label="$t('shiyongshoumingbili')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.mouldLifeProp"></el-input>
            </el-form-item>
            <el-form-item :label="$t('dizengtishibili')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.mouldLifeIncreaseProp"></el-input>
            </el-form-item>
          </div>
          <div v-if="obj.code === 'equipment_idle' || codeName === 'equipment_idle'">
            <el-form-item :label="$t('kongxianshijian(fen)')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.idleTime"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yujingshebei')" required="required">
              <yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentIds"> </yi_cross_select>
            </el-form-item>
          </div>
          <div v-if="obj.code === 'equipment_offline_warning' || codeName === 'equipment_offline_warning'">
            <el-form-item :label="$t('lixianshijian(fen)')" required>
              <el-input-number :min="0" :max="999999" :precision="0" :controls="false" v-model="yt.editObj.intervalTime"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('yujingshebei')" required="required">
              <yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentIds"> </yi_cross_select>
            </el-form-item>
          </div>
          <div v-if="obj.code === 'oil_temperature_too_high' || codeName === 'oil_temperature_too_high'">
            <el-form-item :label="$t('yujingwendu')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.oilTemp"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jiangeshijian(fen)')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.intervalTime"></el-input>
            </el-form-item>
          </div>
          <div v-if="obj.code === 'equipment_run_parameters_exception' || codeName === 'equipment_run_parameters_exception'">
            <el-form-item :label="$t('jiangeshijian(fen)')" required>
              <el-input type="number" oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')" v-model="yt.editObj.intervalTime"></el-input>
            </el-form-item>
          </div>
          <div v-if="obj.code === 'equipment_maintain_bill_warning' || codeName === 'equipment_maintain_bill_warning'">
            <el-form-item :label="$t('tiqiantixingshijian(xiaoshi)')" required>
              <el-input-number :min="0" v-model="yt.editObj.early"></el-input-number>
            </el-form-item>
          </div>

          <div v-if="obj.code === 'equipment_inspection_timeout_warning' || codeName === 'equipment_inspection_timeout_warning'">
            <el-form-item :label="$t('chaoguoshijian(xiaoshi)')" required>
              <el-input-number :min="0" v-model="yt.editObj.time"></el-input-number>
            </el-form-item>
          </div>

          <div v-if="obj.code === 'standard_cycle_compare' || codeName === 'standard_cycle_compare'">
            <el-form-item :label="$t('yunxupianchazhi') + '(%)'" required>
              <el-input-number :min="0" v-model="yt.editObj.percent"></el-input-number>
            </el-form-item>
          </div>

          <div v-if="obj.code === 'wo_report_work_number_difference_warn' || codeName === 'wo_report_work_number_difference_warn'">
            <el-form-item :label="$t('chayileixing')" required>
              <el-select v-model="yt.editObj.differentType">
                <el-option :label="$t('shuliang')" value="number"></el-option>
                <el-option :label="$t('bili')" value="percent"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('chayizhi')" required>
              <el-input-number :min="0" v-model="yt.editObj.differentValue"></el-input-number>
            </el-form-item>
          </div>
          <p class="work">
            <span style="display: flex;margin-left: 15px;margin-top: 10px;">{{ $t('shuoming') }}:</span>
            <span v-if="obj.code === 'over_production' || codeName === 'over_production'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;">{{ $t('shuoming1') }}</span>
            <span v-if="obj.code === 'mould_life' || codeName === 'mould_life'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;">{{ $t('shuoming2') }}</span>
            <span v-if="obj.code === 'equipment_idle' || codeName === 'equipment_idle'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;">{{ $t('shuoming3') }}</span>
            <span v-if="obj.code === 'equipment_run_parameters_exception' || codeName === 'equipment_run_parameters_exception'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;">{{ $t('shuoming4') }}</span>
            <span v-if="obj.code === 'oil_temperature_too_high' || codeName === 'oil_temperature_too_high'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;">{{ $t('shuoming5') }}</span>
            <span v-if="obj.code === 'equipment_offline_warning' || codeName === 'equipment_offline_warning'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;">{{ $t('warning_shuoming6') }}</span>
            <span v-if="obj.code === 'equipment_maintain_bill_warning' || codeName === 'equipment_maintain_bill_warning'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;">{{ $t('warning_shuoming7') }}</span>
            <span v-if="obj.code === 'wo_report_work_number_difference_warn' || codeName === 'wo_report_work_number_difference_warn'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;"> <div v-html="$t('shuoming_wo_report_work_number_difference')"></div></span>
            <span v-if="obj.code === 'equipment_inspection_timeout_warning' || codeName === 'equipment_inspection_timeout_warning'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;"> <div v-html="$t('equipment_inspection_timeout_warning')"></div></span>
            <span v-if="obj.code === 'inspect_auto_create_warning' || codeName === 'inspect_auto_create_warning'" style="display: flex;flex-wrap: wrap;margin-left: 15px;margin-top: 15px;color: #909399;">{{ $t('inspect_auto_create_warning') }}</span>
          </p>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelText()">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="saveText()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog :show-close="true" :title="$t('peizhishijianfanwei')" :visible.sync="showTimekDialog" width="80%" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <time_list ref="time_list" :key="key" :changeTypeId="obj"></time_list>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelCreateDialog">{{ $t('quxiao') }}</el-button>
        <el-button :loading="yt.editObj.loading" size="mini" @click="saveCreateList" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
    <!--编辑-->
    <!--挪动预警编辑-->
    <el-dialog v-if="codeName === 'equipment_move'" :show-close="true" :title="$t('peizhi')" :visible.sync="showEditMovekDialog" width="80%" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <edit_move ref="edit_move" :key="key" :edit="yt.editObj" :changeTypeIds="alertTypeList" @updateSetting="updateSetting"></edit_move>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelEditDialog">{{ $t('quxiao') }}</el-button>
        <el-button :loading="loadingMove" size="mini" @click="saveEdit" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
    <!--配置时间范围编辑-->
    <el-dialog :show-close="true" :title="$t('peizhishijianfanwei')" :visible.sync="showEditkDialogList" width="80%" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <edit_list ref="edit_list" :key="key1" :edit="yt.editObj" :changeTypeId="alertTypeList"></edit_list>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelTimekDialog">{{ $t('quxiao') }}</el-button>
        <el-button :loading="loading" size="mini" @click="saveEditList" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import message_view from '@@/pages/web/early_warning_management/alert_settings/message_view';
import time_list from '@@/pages/web/early_warning_management/alert_settings/time_list';
import move_list from '@@/pages/web/early_warning_management/alert_settings/move_list';
import edit_list from '@@/pages/web/early_warning_management/alert_settings/edit_list';
import edit_move from '@@/pages/web/early_warning_management/alert_settings/edit_move';
import equipment_user_list from '@@/pages/web/early_warning_management/alert_settings/equipment_user_list';

export default {
  name: 'web_early_warning_management_alert_settings_list',
  components: {
    message_view,
    time_list,
    edit_list,
    move_list,
    edit_move,
    equipment_user_list
  },
  data() {
    return {
      loading: false,
      loadingMove: false,
      // 消息机器人列表
      robotList: [],
      // 显示机器人列表
      showRobotList: false,
      // 显示用户列表
      showUserList: false,
      // 用户交叉选择固定条件：仅可选已启用账号（与系统用户页「是否启用」一致）；仅预警设置传入，不影响其它页面
      warningUserCrossSelectFixConditions: { enabled: true },
      itemList: [],
      key: 0,
      key1: 0,
      obj: {},
      list: [],
      explain: '',
      codeName: '',
      editList: null,
      alertTypeList: [],
      userList: [],
      changeTypeId: null,
      changeEditTypeId: null,
      paramsList: null,
      showSpotCheckDialog: false,
      showEquipmentUserDialog: false,
      showTimekDialog: false,
      showEditkDialogList: false,
      showEditMovekDialog: false,
      mould_life: '',
      columns: [
        {
          label: 'yewuleixing',
          prop: 'warningType.type'
          // type: 'slot',
        },
        {
          label: 'yewumingcheng',
          prop: 'warningType.name'
        },
        {
          label: 'tongzhiqudao',
          prop: 'channels',
          type: 'dictionary',
          key: 'MESSAGE_CHANNEL'
        },
        {
          label: 'yonghu',
          prop: 'userObjects.nickname',
          type: 'slot'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'shifouqiyong',
          prop: 'isEnabled',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          width: 150,
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    'yt.isShowEditDialog': {
      handler(n) {
        // console.log('ggggg', n)
        if (this.yt.editObj.action == 'xinzeng' && n == false) {
          this.yt.editObj.warningTypeId = null;
          this.obj = {};
          this.codeName = null;
          ++this.key;
        }
        if (this.yt.editObj.action == 'bianji' && n == false) {
          this.yt.editObj.warningTypeId = null;
          this.obj = {};
          this.codeName = null;
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = '/web/system/auth/user/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'nickname';
      this.yt.get(1, this.beforeGet, this.afterGet);
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
    }, 300);
  },
  filters: {
    getUserText(value) {
      return value
        .map(item => {
          return item.nickname;
        })
        .join(',');
    }
  },
  methods: {
    // 加载消息机器人列表
    getRobotList() {
      this.http
        .get(`/web/msg/config/robot/list`)
        .then(res => {
          this.robotList = res.data || [];
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      row.isEnabled = 1;
      this.getWarning();
      this.getUser();
      this.getRobotList();
      return row;
    },
    // 编辑之前处理数据
    beforeShowEditDialogEdit(row) {
      this.getWarning(this.yt.editObj);
      this.getUser();
      this.getRobotList();
      this.channelChange();
      this.editList = row;
      return row;
    },
    // 获取机器人类型名称
    getRobotTypeName(robotType) {
      const name = this.store.state.dictJson['MSG_CONFIG_ROBOT_TYPE'][robotType] || '';
      return this.$t(name);
    },
    // 通知渠道更改时调用
    channelChange() {
      // 只有选中了机器人类型的额通知渠道才显示机器人列表
      const channels = this.yt.editObj.channels || [];
      this.showRobotList = channels.includes('5');
      const userChannels = ['0', '1'];
      this.showUserList = false;
      for (let i = 0; i < userChannels.length; i++) {
        const userChannel = userChannels[i];
        if (channels.includes(userChannel)) {
          this.showUserList = true;
          return;
        }
      }
    },
    updateSetting(value) {
      this.$set(this.yt.editObj, 'settingJson', JSON.stringify(value));
    },
    beforeAdd(params, url) {
      if (params) {
        if (this.obj.code === 'equipment_move' || this.codeName === 'equipment_move') {
          const settingJson = params.settingJson;
          if (settingJson) {
            const list = JSON.parse(settingJson);
            for (let i = 0; i < list.length; i++) {
              delete list[i].equipment;
            }
            params.settingJson = JSON.stringify(list);
          }
        }
      }
      return params;
    },
    cancelEditDialog() {
      this.showEditMovekDialog = false;
    },
    cancelCreateDialog() {
      this.showTimekDialog = false;
      this.showSpotCheckDialog = false;
      this.showEquipmentUserDialog = false;
      ++this.key;
    },
    cancelTimekDialog() {
      this.showEditkDialogList = false;
      ++this.key1;
    },
    saveCreateList() {
      if (this.$refs['time_list']._data.tableData) {
        this.showTimekDialog = false;
      }
    },
    saveMoveList() {
      if (this.$refs['move_list']._data.tableData) {
        this.showSpotCheckDialog = false;
      }
    },
    saveCreate() {
      //配置挪动预警
      if (this.$refs['move_list'] || this.$refs['time_list']) {
        if (this.$refs['move_list']) {
          if (this.$refs['move_list'] && (this.$refs['move_list']._data !== undefined || this.$refs['move_list']._data !== '')) {
            this.paramsList = {
              ...this.yt.editObj,
              settingJson: JSON.stringify([...this.$refs['move_list']._data.tableData])
            };
          }
        }

        //配置时间范围
        if (this.$refs['time_list']) {
          if (this.$refs['time_list'] && (this.$refs['time_list']._data !== undefined || this.$refs['time_list']._data !== '')) {
            this.paramsList = {
              ...this.yt.editObj,
              warningTimeFrameList: [...this.$refs['time_list']._data.tableData]
            };
          }
        }
      } else {
        this.paramsList = {
          ...this.yt.editObj
        };
      }

      return this.http
        .post('/web/warning/setting/create', this.paramsList)
        .then(response => {
          this.yt.isShowEditDialog = false;
          this.yt.get(1, this.beforeGet, this.afterGet);
          ++this.key;
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    update() {
      let params = this.utils.copy(this.yt.editObj);
      params = this.beforeAdd(params);
      this.http
        .post('/web/warning/setting/update', params)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get(1, this.beforeGet, this.afterGet);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    saveEdit() {
      if (this.$refs['edit_move']._data.tableData) {
        this.showEditMovekDialog = false;
      }
    },
    saveEditList() {
      if (this.$refs['edit_list']._data.tableData) {
        this.showEditkDialogList = false;
      }
    },
    beforeGet(params) {
      console.log('params', params);
      params['orderBy'] = 'createTime desc';
      return params;
    },
    afterGet(result) {
      if (result.data.rows.length > 0) {
        for (let i = 0; i < result.data.rows.length; i++) {
          let row = result.data.rows[i];
          if (row.settingJson && row.warningType.code === 'equipment_maintain_bill_warning') {
            let json = JSON.parse(row.settingJson);
            row.early = json.early;
          } else if (row.settingJson && row.warningType.code === 'wo_report_work_number_difference_warn') {
            let json = JSON.parse(row.settingJson);
            row.differentValue = json.differentValue;
            row.differentType = json.differentType;
          } else if (row.settingJson && row.warningType.code === 'equipment_inspection_timeout_warning') {
            let json = JSON.parse(row.settingJson);
            row.time = json.time;
          } else if (row.settingJson && row.warningType.code === 'inspect_auto_create_warning') {
            let json = JSON.parse(row.settingJson);
            this.$set(row, 'inspectionType', json.inspectionType);
          } else if (row.settingJson && row.warningType.code === 'standard_cycle_compare') {
            let json = JSON.parse(row.settingJson);
            this.$set(row, 'percent', json.percent);
          }
        }
      }
      return result;
    },
    //监听业务类型/名称的变化
    changeValue(value) {
      this.changeTypeId = value;
      console.log('value', value);
      if (Array.isArray(this.alertTypeList) && this.alertTypeList.length > 0) {
        this.obj = this.alertTypeList.find(item => {
          return item.id === value;
        });
      }
      console.log('this.obj', this.obj);
    },
    changeEditValue(value) {
      this.changeEditTypeId = value;
      console.log('value', value);
    },
    showMoveText() {
      this.showEditMovekDialog = true;
    },
    showText() {
      if (this.yt.editObj.warningTypeId) {
        if (this.obj.code === 'equipment_fault_group' || this.obj.code === 'equipment_remove_fault_group' || this.codeName === 'equipment_fault_group' || this.codeName === 'equipment_remove_fault_group') {
          this.showEquipmentUserDialog = true;
        } else {
          this.showSpotCheckDialog = true;
        }
      } else {
        this.utils.errorMessage(this.$t('qingxianxuanzeyewuleixing'));
      }
    },
    showTime() {
      if (this.yt.editObj.warningTypeId) {
        this.showTimekDialog = true;
      } else {
        this.utils.errorMessage(this.$t('qingxianxuanzeyewuleixing'));
      }
      // showTimekDialog
      // this.showTimekDialog = true
    },
    showEdit(row) {
      this.showEditkDialogList = true;
      this.itemList = row;
      this.utils.event_hub.$emit('SETTING_READ_REFRESHS', this.unreadSizeTtotal);
      console.log('rowwwwwwwww', row);
    },
    saveText() {
      // this.explain = 1
      //生产预警/工单超产量
      if (this.obj.code === 'over_production' || this.codeName === 'over_production') {
        if (this.yt.editObj.overProductionType == null || this.yt.editObj.overProductionType === '') {
          this.utils.errorMessage(this.$t('chaochanleixingbunengweikong'));
          return false;
        }
        if (this.yt.editObj.overProductionValue == null || this.yt.editObj.overProductionValue == '') {
          this.utils.errorMessage(this.$t('chaochanzhibunengweikong'));
          return false;
        }
        if (this.yt.editObj.overProductionInterval == null || this.yt.editObj.overProductionInterval == '') {
          this.utils.errorMessage(this.$t('jiangechaochanzhitixingbunengweikong'));
          return false;
        }
        if (this.yt.editObj.overProductionType == null && this.yt.editObj.overProductionValue == null && this.yt.editObj.overProductionInterval == null) {
          return false;
        } else {
          this.showSpotCheckDialog = false;
        }
      }
      //生产预警/模具寿命
      if (this.obj.code === 'mould_life' || this.codeName === 'mould_life') {
        if (this.yt.editObj.mouldLifeProp == null || this.yt.editObj.mouldLifeProp == '') {
          this.utils.errorMessage(this.$t('shiyongshoumingbilibunengweikong'));
          return false;
        }
        if (this.yt.editObj.mouldLifeIncreaseProp == null || this.yt.editObj.mouldLifeIncreaseProp == '') {
          this.utils.errorMessage(this.$t('dizengtishibilibunengweikong'));
          return false;
        }
        if ((this.yt.editObj.mouldLifeProp == null || this.yt.editObj.mouldLifeProp == '') && (this.yt.editObj.mouldLifeIncreaseProp == null || this.yt.editObj.mouldLifeIncreaseProp == '')) {
          return false;
        } else {
          this.showSpotCheckDialog = false;
        }
      }
      //生产预警/设备空闲
      if (this.obj.code === 'equipment_idle' || this.codeName === 'equipment_idle') {
        if (this.yt.editObj.idleTime == null || this.yt.editObj.idleTime == '') {
          this.utils.errorMessage(this.$t('kongxianshijianbunengweikong'));
          return false;
        }
        if (this.yt.editObj.equipmentIds == null || this.yt.editObj.equipmentIds == '') {
          this.utils.errorMessage(this.$t('yvjingshebeibunengweikong'));
          return false;
        }
        if (this.yt.editObj.idleTime == null && this.yt.editObj.equipmentIds == null) {
          return false;
        } else {
          this.showSpotCheckDialog = false;
        }
      }
      //参数预警/设备运行参数异常
      if (this.obj.code === 'equipment_run_parameters_exception' || this.codeName === 'equipment_run_parameters_exception') {
        if (this.yt.editObj.intervalTime == null || this.yt.editObj.intervalTime == '') {
          this.utils.errorMessage(this.$t('jiangeshijianbunengweikong'));
          return false;
        } else {
          this.showSpotCheckDialog = false;
        }
      }
      //
      if (this.obj.code === 'oil_temperature_too_high' || this.codeName === 'oil_temperature_too_high') {
        if (this.yt.editObj.oilTemp == null || this.yt.editObj.oilTemp == '') {
          this.utils.errorMessage(this.$t('yvjingwendubunengweikong'));
          return false;
        }
        if (this.yt.editObj.intervalTime == null || this.yt.editObj.intervalTime == '') {
          this.utils.errorMessage(this.$t('jiangeshijianbunengweikong'));
          return false;
        } else {
          this.showSpotCheckDialog = false;
        }
      }
      //生产预警/设备离线
      if (this.obj.code === 'equipment_offline_warning' || this.codeName === 'equipment_offline_warning') {
        console.log(this.yt.editObj.intervalTime);
        if (this.yt.editObj.intervalTime == null) {
          this.utils.errorMessage(this.$t('jiangeshijianbunengweikong'));
          return false;
        } else {
          this.showSpotCheckDialog = false;
        }
      }
      // 设备保养
      if (this.obj.code === 'equipment_maintain_bill_warning' || this.codeName === 'equipment_maintain_bill_warning') {
        if (this.yt.editObj.early === null || this.yt.editObj.early === '') {
          console.log(this.yt.editObj.early);
          this.utils.errorMessage(this.$t('tiqiantixingshijianbunengweikong'));
          return false;
        } else {
          this.yt.editObj.settingJson = JSON.stringify({ early: this.yt.editObj.early });
          this.showSpotCheckDialog = false;
        }
      }
      //设备点检
      if (this.obj.code === 'equipment_inspection_timeout_warning' || this.codeName === 'equipment_inspection_timeout_warning') {
        if (this.yt.editObj.time === undefined || this.yt.editObj.time === null || this.yt.editObj.time === '') {
          console.log(this.yt.editObj.time);
          this.utils.errorMessage(this.$t('超时时间不能为空'));
          return false;
        } else {
          console.log(this.yt.editObj.time);
          this.yt.editObj.settingJson = JSON.stringify({ time: this.yt.editObj.time });
          this.showSpotCheckDialog = false;
        }
      }

      if (this.obj.code === 'wo_report_work_number_difference_warn' || this.codeName === 'wo_report_work_number_difference_warn') {
        console.log(this.yt.editObj.differentValue);
        console.log(this.yt.editObj.differentType);
        if (this.yt.editObj.differentValue === undefined || this.yt.editObj.differentType === undefined) {
          this.utils.errorMessage(this.$t('bunengweikong'));
          return false;
        } else {
          this.yt.editObj.settingJson = JSON.stringify({ differentValue: this.yt.editObj.differentValue, differentType: this.yt.editObj.differentType });
          this.showSpotCheckDialog = false;
        }
      }
      //标准周期对比
      if (this.obj.code === 'standard_cycle_compare' || this.codeName === 'standard_cycle_compare') {
        if (this.yt.editObj.percent === null || this.yt.editObj.percent === '' || this.yt.editObj.percent === undefined) {
          this.utils.errorMessage(this.$t('yunxupianchazhi') + '(%)' + this.$t('bunengweikong'));
          return false;
        } else {
          this.yt.editObj.settingJson = JSON.stringify({ percent: this.yt.editObj.percent });
          this.showSpotCheckDialog = false;
        }
      }

      if (this.obj.code === 'inspect_auto_create_warning' || this.codeName === 'inspect_auto_create_warning') {
        if (this.yt.editObj.inspectionType === null || this.yt.editObj.inspectionType === undefined) {
          this.utils.errorMessage(this.$t('请选择检验类型'));
          return false;
        } else {
          this.yt.editObj.settingJson = JSON.stringify({ inspectionType: this.yt.editObj.inspectionType });
          this.showSpotCheckDialog = false;
        }
      }
    },
    cancelText() {
      // this.explain = null
      this.showSpotCheckDialog = false;
    },
    getWarning(editObj) {
      // console.log("editObj:", editObj)
      // if (editObj.settingJson) {
      //   try {
      //     this.initSetting = JSON.parse(editObj.settingJson)
      //   } catch (e) {
      //
      //   }
      // }
      this.http
        .get('/web/warning/type/page', {
          params: {
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.alertTypeList = res.data.rows;
          let typeName = '';
          for (let i = 0; i < this.alertTypeList.length; i++) {
            if (this.yt.editObj.action === 'bianji') {
              if (this.yt.editObj.warningTypeId === this.alertTypeList[i]['id']) {
                console.log('typeId', this.yt.editObj.warningTypeId);
                console.log('this.alertTypeList[i]', this.alertTypeList[i]);
                this.codeName = this.alertTypeList[i]['code'];
                console.log('codeName', this.alertTypeList[i]['code']);
              }
            }

            this.alertTypeList[i].typeName = this.alertTypeList[i]['type'] + '/' + this.alertTypeList[i]['name'];
          }
        })
        .catch(msg => {
          // this.utils.errorMessage(msg);
        });
    },
    getUser() {
      this.http
        .get('/web/customer/auth/user/page', {
          params: {
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.userList = res.data.rows;
        });
    },
    saveEquipmentUser() {
      this.$set(this.yt.editObj, 'settingJson', JSON.stringify(this.$refs['equipment_user_list']._data.list));
      setTimeout(() => {
        this.showEquipmentUserDialog = false;
      }, 300);
    }
  }
};
</script>
